import ScheduleAppointment from "../components/ClientSheduleAppointment/scheduleAppointment";
import ScheduleAppointmentV2 from "../components/ClientSheduleAppointment/scheduleAppointmentV2";
import useFeatureStore from "../store/FeatureStore";

function ScheduleAppointmentPage() {
  const { featureFlags } = useFeatureStore();

  return (
    <>
      {process.env.REACT_APP_DASHBOARD_TWO_ENABLE === 'true' &&
      !featureFlags?.dashboardV2 ? <ScheduleAppointment /> : <ScheduleAppointmentV2 />}
    </>
  )
}

export default ScheduleAppointmentPage;
